export const WEB_VIEW_PROPERTIES = {
  AUTHENTICATION: "webview_authentication",
  REFRESH_TOKEN: "webview_refresh_token",
  RETURN_URL: "webview_return_url",
} as const;
